import { Component } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { Router } from '@angular/router'; // Add this import
import {jwtDecode} from 'jwt-decode';
import { environment } from '../../environments/environment';
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    MatButtonModule,
    MatCardModule,
    MatProgressBarModule,
    MatToolbarModule,
    MatIconModule,
    MatExpansionModule,
    MatTooltipModule,
    MatDividerModule,
    MatListModule,
    CommonModule
  ],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {
  polling: boolean = false;
  verificationStatus: string = ''; // For Accepted/Rejected status
  asyncResults: any = null; // For async results
  apiResponse: string = '';
  private apiKey = '';
  private idv_url = '';
  private logoutURL = window.location.origin;


  constructor(
    private oauthService: OAuthService,
    private snackBar: MatSnackBar,
    private http: HttpClient,
    private router: Router 
  ) {}

  get accessToken() {
    return this.oauthService.getAccessToken();
  }

  get idToken() {
    // console.log('this.forgeRockcookie')
    // console.log(this.forgeRockCookie)
    // console.log(this.userProperties)
    // console.log(this.userProperties)
    return this.oauthService.getIdToken();
  }
  get forgeRockCookie() {
    return this.oauthService.getIdentityClaims()['org.forgerock.openidconnect.ops']
  }
  get userName() {
    const decoded: any = jwtDecode(this.oauthService.getIdToken())
    // console.log('decoded')
    // console.log(decoded)
    return decoded.given_name;
  }

  isAuthenticated() {   
      return this.oauthService.hasValidAccessToken();
  }

  login() {
    this.oauthService.initCodeFlow();
  }

  register() {
    window.location.href = environment.loginApp+'/register';
  }

  logout() {
    // console.log('this.idToken')
    // console.log(this.idToken)
    const idToken = this.idToken
    // Clear local session data
    this.oauthService.logOut();
    sessionStorage.clear();
    localStorage.clear();
   
    this.oauthService.logOut()
    // Redirect to PingFederate logout endpoint
    
    const relayState = encodeURIComponent(window.location.origin); // Redirect back to home page after logout
    const logoutUrl = `${environment.ping}/am/oauth2/alpha/connect/endSession?id_token_hint=${idToken}&post_logout_redirect_uri=${window.location.origin}`
    window.location.href = logoutUrl;
  }


  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.snackBar.open('Copied to clipboard!', 'Close', { duration: 2000 });
    }).catch((err) => {
      console.error('Failed to copy text:', err);
    });
  }

  launchSaml () {    
    window.location.href = 'https://orgfarm-e61d4f8b1a-dev-ed.develop.my.salesforce.com';
  }


  
}